import styled from 'styled-components'
import { ImageAsset } from '@/components/common'
import { LinkButton } from '@/components/common/buttons'
import FlatIcon from '@/components/common/icons/FlatIcon'
import { BannerTopSlim } from '@/components/domains/banners'
import { CartItemCountCircle } from '@/components/domains/etc'
import { FitpetMallEventEnum } from '@/constants/fitpet-mall-event.enum'
import { IconNameEnum } from '@/constants/icon-name.enum'
import { IconSizeEnum } from '@/constants/icon-size.enum'
import { Z_INDEXES } from '@/constants/legacy/constLayout'
import ROUTES from '@/constants/legacy/constRoutes'
import { QueryStringKeyEnum } from '@/constants/query-string-key.enum'
import { useTracker } from '@/containers/contexts/EventTrackingProvider'
import { useCustomRouter, usePetType } from '@/containers/hooks'
import { Bridge } from '@/utils/bridge/bridge'
import appBridgeProvider, { isInAppFlag } from '@/utils/utilBridge'

export const ProductDetailTopNavi = () => {
  const { query } = useCustomRouter()
  const tracker = useTracker()
  const { getPetType } = usePetType()
  return (
    <ProductDetailTopNaviWrapper className="product-detail-top-navi">
      <BannerTopSlim />
      <header className="product-detail-top-navi__content">
        <LinkButton goBack>
          <ImageAsset name="ic_left" size={24} svg={true} />
        </LinkButton>
        <nav className="product-detail-top-navi__nav">
          <LinkButton
            url={isInAppFlag ? undefined : ROUTES.INDEX}
            onClick={() => {
              tracker.triggerCustomEvent(FitpetMallEventEnum.ClickGnbHomeIcon)
              if (isInAppFlag) appBridgeProvider((bridge: Bridge) => bridge.goDeepLink('fitpetmall', '/main'))
            }}
          >
            <FlatIcon type={IconNameEnum.IcHome} size={IconSizeEnum.Size24} />
          </LinkButton>
          <LinkButton
            rel="nosublink"
            url={{
              pathname: ROUTES.SEARCH,
              query: {
                [QueryStringKeyEnum.SearchPetType]: query?.[QueryStringKeyEnum.SearchPetType] || getPetType(),
              },
            }}
            onClick={() => {
              tracker.triggerCustomEvent(FitpetMallEventEnum.ClickGnbSearchIcon)
            }}
          >
            <FlatIcon type={IconNameEnum.IcSearch} size={IconSizeEnum.Size24} />
          </LinkButton>
          <LinkButton
            rel="nosublink"
            url={ROUTES.CART}
            style={{
              position: 'relative',
            }}
          >
            <CartItemCountCircle />
            <FlatIcon type={IconNameEnum.IcCart} size={IconSizeEnum.Size24} />
          </LinkButton>
        </nav>
      </header>
    </ProductDetailTopNaviWrapper>
  )
}

const ProductDetailTopNaviWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: ${Z_INDEXES.HEADER};
  background-color: ${({
    theme: {
      color: { grayWhite },
    },
  }) => grayWhite};
  border-bottom: 0.1rem solid
    ${({
      theme: {
        color: { gray50 },
      },
    }) => gray50};
  .product-detail-top-navi {
    &__content {
      height: 5.6rem;
      padding: 1.6rem;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
    &__nav {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 1.6rem;
    }
  }
`
